import storage from "components/common/storage";

const PAGINATION_SIZE_STORAGE_KEY = "paginationSize";
export const DEFAULT_PAGINATION_SIZE = 5;

export const rowsPerPageOptions = [5, 10, 25, 50, 100];

const [fetchPaginationSize, storePaginationSize] = storage(PAGINATION_SIZE_STORAGE_KEY, {
  defaultValue: DEFAULT_PAGINATION_SIZE,
});

export default { fetchPaginationSize, storePaginationSize };
